import React, { useEffect } from 'react'

import Lottie from "lottie-react";
import doneLottie from "../done_lottie.json";
import { useNavigate } from 'react-router-dom';

const DonationSuccessPageHE = () => {
  const navigate = useNavigate()

  useEffect(()=>{
    setTimeout(()=>{
      navigate('/donate/success-he/2')
    }, 8000);
  },[]);

  return (
    <div
    dir='rtl'
      className="w-full bg-blue-50 h-screen"
      style={{
        backgroundImage: "url('/assets/donate_page/donate_page_bg.webp')",
      }}
    >
      <div className="w-11/12 h-full sm:mt-0 mx-auto shadow-2xl md:w-1/2 rounded-3xl bg-white px-8 py-6 flex flex-col items-center justify-center">
       
        <Lottie animationData={doneLottie} loop={false} className='w-full h-64' />

        <p className='text-2xl text-center'>ההעברה בוצעה בהצלחה!</p>

        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"></path><path d="M3 7h3"></path><path d="M3 11h2"></path><path d="M9.02 8.801l-.6 6a2 2 0 0 0 1.99 2.199h7.98a2 2 0 0 0 1.99 -1.801l.6 -6a2 2 0 0 0 -1.99 -2.199h-7.98a2 2 0 0 0 -1.99 1.801z"></path><path d="M9.8 7.5l2.982 3.28a3 3 0 0 0 4.238 .202l3.28 -2.982"></path></svg>

        <p className="text-center mt-4">
        אישור ההעברה ישלח לאמייל שלך בהקדם האפשרי
        </p>
        <p className="mt-4 text-green-500">
        כבר תועבר לעמוד הבא…
        </p>
      </div>
    </div>
  )
}

export default DonationSuccessPageHE